<ng-container *ngIf="startRender">
  <mat-form-field appearance="outline" [formGroup]="formGroup">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput placeholder="{{placeholderText}}" type="text" aria-label="Mobile" [formControl]="formControl" tabindex="{{tabindex}}">
    <mat-error>
      Please enter a valid email.
    </mat-error>
    <mat-spinner style="margin-top: 12px" [diameter]="20" *ngIf="formControl.status === 'PENDING'"></mat-spinner>
  </mat-form-field>
</ng-container>
